import { useTranslation } from 'react-i18next';
import { LuBug } from 'react-icons/lu';

import { HeaderButton } from '~/components/Header/HeaderButton';
import { useSentryFeedback } from '~/hooks/useSentryFeedback';

export const ReportBugHeaderButton: React.FC = () => {
    const { t } = useTranslation();
    const { elementRef, isAvailable } = useSentryFeedback<HTMLButtonElement>();

    if (isAvailable === false) {
        return null;
    }

    return (
        <HeaderButton
            ref={elementRef}
            type="button"
            data-testid="report-bug-header-button"
            iconLeft={<LuBug className="size-4" aria-hidden />}
            aria-label={t('COMMON.REPORT_A_BUG')}
        >
            {t('COMMON.REPORT_A_BUG')}
        </HeaderButton>
    );
};
